import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ModalComponent } from '../../../../core/components/modal/modal.component';
import { DropdownQuestion, DynamicFormComponent, QuestionBase, TextboxQuestion } from 'core/components/forms';
import { environment } from 'environments/environment';

@Component({
  selector: 'lms-translation-modal',
  templateUrl: './translation-modal.component.html',
  styleUrls: ['./translation-modal.component.scss']
})
export class TranslationModalComponent {
  @Output() confirmTranslation = new EventEmitter<Object>();
  kpisQuestions: QuestionBase<any>[] = [];
  kpisTranslatedQuestions: QuestionBase<any>[] = [];
  @ViewChild('modal', { static: false }) public modal: ModalComponent;
  @ViewChild('translationForm', { static: false }) public translationForm: DynamicFormComponent;

  constructor(public translateService: TranslateService) {}

  public openModal(data) {
    this.kpisQuestions = this.createQuestion(data, data.source);
    this.kpisTranslatedQuestions = this.createQuestion(data, data.dest);
    this.modal.open();
  }

  createQuestion(data, lang: string) {
    const isBase = data.source === lang;
    const { keplerLanguages } = environment;
    const languages = lang
      ? keplerLanguages.filter((l) => l.key === lang)
      : keplerLanguages.filter((l) => !data.translations.includes(l.key));
    const questions = data.kpis.map(
      (k) =>
        new TextboxQuestion({
          key: k.id,
          value: lang && k.name[lang] ? k.name[lang] : '',
          editable: !isBase,
          validators: { required: !isBase },
          hideRequiredMark: true
        })
    );
    questions.unshift(
      new DropdownQuestion({
        key: 'lang',
        value: lang,
        editable: !isBase && !lang,
        options: languages.map(({ key, value }) => ({ key, value: this.translateService.instant(value) })),
        validators: { required: !isBase },
        hideRequiredMark: true
      })
    );
    return questions;
  }

  confirm() {
    const { lang, ...kpis } = this.translationForm.form.value;
    const tranlationResult = {
      lang,
      names: Object.keys(kpis).map((k) => kpis[k])
    };
    this.confirmTranslation.emit(tranlationResult);
    this.modal.close();
  }
}
